import DatePicker from "../DatePicker/DatePicker";
import "./DateRangePicker.scss";

function toDateValue(value) {
  if (!value) return null;
  if (value instanceof Date) return value;
  return new Date(value + "T00:00:00");
}

function toISODateString(date) {
  if (!date) return "";
  const d = new Date(date);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

function DateRangePicker({
  label = "Obdobie",
  startLabel = "Od",
  endLabel = "Do",
  value,
  onChange,
  disabled = false,
  className = "",
}) {
  const startDate = toDateValue(value?.startDate);
  const endDate = toDateValue(value?.endDate);

  const handleStartChange = (nextStartDate) => {
    if (!nextStartDate) return;
    let normalizedEndDate = endDate;
    if (normalizedEndDate && nextStartDate > normalizedEndDate) {
      normalizedEndDate = nextStartDate;
    }

    onChange?.({
      startDate: toISODateString(nextStartDate),
      endDate: normalizedEndDate ? toISODateString(normalizedEndDate) : toISODateString(nextStartDate),
    });
  };

  const handleEndChange = (nextEndDate) => {
    if (!nextEndDate) return;
    let normalizedStartDate = startDate;
    if (normalizedStartDate && nextEndDate < normalizedStartDate) {
      normalizedStartDate = nextEndDate;
    }

    onChange?.({
      startDate: normalizedStartDate ? toISODateString(normalizedStartDate) : toISODateString(nextEndDate),
      endDate: toISODateString(nextEndDate),
    });
  };

  return (
    <div className={`date-range-picker ${className}`.trim()}>
      {label && <span className="date-range-picker__label">{label}</span>}
      <div className="date-range-picker__inputs">
        <DatePicker
          label={startLabel}
          value={startDate}
          onChange={handleStartChange}
          maxDate={endDate || undefined}
          disabled={disabled}
          placeholder="Vyber od"
          className="date-range-picker__input"
        />
        <DatePicker
          label={endLabel}
          value={endDate}
          onChange={handleEndChange}
          minDate={startDate || undefined}
          disabled={disabled}
          placeholder="Vyber do"
          className="date-range-picker__input"
        />
      </div>
    </div>
  );
}

export default DateRangePicker;
